// extracted by mini-css-extract-plugin
export default {"policyText":"policyText__policyText--XYGGW","policyLink":"policyText__policyLink--I7Qbr"};